import EmptyWorkflowImage from 'resources/images/workflow/workflow-empty-state.svg';
import {
  Button, ButtonVariant, Text,
} from '@usealloy/component-library';
import { StyledAnimatedImage, StyledEmptyStateContainer, StyledDescriptionText } from './styles';
import type { MenuBarModalGroup } from '~/dashboard/views/workflows/editor/components/MenuBar/MenuBarModals/types';
import { selectWorkflowIsSnippet } from 'flow/store/redux/selectors/general';
import { useAppSelector } from '~/store/reduxHooks';


interface WorkflowCanvasEmptyStateProps {
  modalGroup: MenuBarModalGroup;
}

export default function WorkflowCanvasEmptyState({ modalGroup }: WorkflowCanvasEmptyStateProps) {
  const isSnippetWorkflow = useAppSelector(selectWorkflowIsSnippet);

  const handleOpenLibraryModal = () => {
    modalGroup.open('policyLibrary');
  };

  return (
    <StyledEmptyStateContainer
      direction="column"
      alignItems="center"
      justifyContent="flex-start"
      gap={5}
    >
      <Text as="h3" weight={500} size={4} lineHeight={4}>Get started building your {isSnippetWorkflow ? 'Snippet' : 'Workflow'}</Text>
      <StyledAnimatedImage
        src={EmptyWorkflowImage}
        alt="Empty Workflow"
      />
      <StyledDescriptionText
        size={3}
        lineHeight={4}
      >
        Use the &quot;Add&quot; menu above to add Services and Input Attributes
        {isSnippetWorkflow ? '.' : ', or rules from the Policy Library.'}
      </StyledDescriptionText>
      {!isSnippetWorkflow && (
        <Button
          variant={ButtonVariant.primary}
          onClick={handleOpenLibraryModal}
        >
          Explore Policy Library
        </Button>
      )}
    </StyledEmptyStateContainer>
  );
}
